'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventItem(_ref) {
  var event = _ref.event,
      openModal = _ref.openModal,
      destroy = _ref.destroy,
      feature = _ref.feature,
      polyglot = _ref.polyglot,
      calendar = _ref.calendar,
      moment = _ref.moment,
      unlink = _ref.unlink;

  var lastUpdatedAt = moment(event.updated_at).format('LL');
  var startDate = moment(event.start_date).format('Do MMMM');
  var endDate = event.end_date ? moment(event.end_date).format('Do MMMM') : startDate;
  var nextDate = event.next_date ? moment(event.next_date).format('Do MMMM') : startDate;

  var hasCalendar = calendar && (0, _can2.default)('admin', calendar);
  var starClasses = (0, _classnames2.default)({
    'col-md-1 result-feature': true,
    featured: event.featured,
    calendar: hasCalendar,
    hidden: !hasCalendar
  });
  var mainColumnsClasses = (0, _classnames2.default)({
    'col-md-10': hasCalendar,
    'col-md-11': !hasCalendar
  });

  return _react2.default.createElement(
    'div',
    { className: 'row-fluid result' },
    _react2.default.createElement('a', {
      className: starClasses,
      href: '#',
      onClick: feature.bind.call(feature, this, event)
    }),
    _react2.default.createElement(
      'a',
      {
        className: mainColumnsClasses,
        onClick: openModal
      },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-1 result-img' },
          event.thumbnail_url && _react2.default.createElement('img', { src: event.thumbnail_url, width: '72', height: '72', alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-6 result-info' },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'b',
              null,
              polyglot.t('events.dateCount', event.event_dates_count)
            ),
            '\xA0',
            nextDate !== startDate ? nextDate : '',
            ' ',
            '(',
            startDate,
            startDate !== endDate ? ' ' + polyglot.t('events.to') + ' ' + endDate : '',
            ')'
          ),
          _react2.default.createElement(
            'h3',
            null,
            event.title
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              null,
              event.venue ? event.venue.name : null
            ),
            ' ',
            _react2.default.createElement(
              'span',
              null,
              parseInt(event.venues_count, 10) > 1 && "et d'autres lieux"
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-5 result-meta' },
          _react2.default.createElement(
            'span',
            { className: 'label-' + event.status },
            polyglot.t('events.status.' + event.status)
          ),
          _react2.default.createElement('br', null),
          polyglot.t('events.createdBy', { author: event.author.name }),
          _react2.default.createElement('br', null),
          polyglot.t('events.updatedAt', { date: lastUpdatedAt })
        )
      )
    ),
    hasCalendar && !calendar.options.allowEventDelete ? _react2.default.createElement('a', {
      className: 'col-md-1 result-unlink',
      href: '#',
      onClick: unlink.bind(this, event.id, event.calendar_id)
    }) : _react2.default.createElement('a', {
      className: 'col-md-1 result-delete',
      href: '#',
      onClick: destroy.bind(this, event.id)
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Event/EventItem.js
// module id = 2193
// module chunks = 0